const foodEmojis = {
  banana: '🍌',
  bread: '🍞',
  burger: '🍔',
  cantaloupe: '🍈',
  cheese: '🧀',
  cheese_wedge: '🧀',
  cheeseburger: '🍔',
  cheesewedge: '🧀',
  croissant: '🥐',
  doughnut: '🍩',
  grape: '🍇',
  grapes: '🍇',
  green_apple: '🍏',
  hamburger: '🍔',
  honeydew: '🍈',
  hot_dog: '🌭',
  hotdog: '🌭',
  lemon: '🍋',
  lemonade: '🍋',
  load_of_bread: '🍞',
  loadofbread: '🍞',
  mandarin: '🍊',
  melon: '🍈',
  muskmelon: '🍈',
  orange: '🍊',
  pancakes: '🥞',
  peach: '🍑',
  pear: '🍐',
  pineapple: '🍍',
  plantain: '🍌',
  rockmelon: '🍈',
  sausage: '🌭',
  taco: '🌮',
  tangerine: '🍊',
  tomato: '🍅',
  watermelon: '🍉',
  yellow_fruit: '🍋',
  yellowfruit: '🍋'
}

module.exports = foodEmojis
